import Vue from 'vue';

Vue.component('index-deposit-tabs', require('./components/application/IndexTabs').default);
Vue.component('index-deposit-rejected', require('./components/application/IndexDepositRejected').default);
Vue.component('index-deposit', require('./components/application/IndexDeposit').default);
//Vue.component('deposit-modal', require('./components/application/DepositModal').default);
Vue.component('deposit-edit', require('./components/application/DepositEdit').default);

Vue.component('index-income', require('./components/application/income/IndexIncome').default);
// Vue.component('income-modal', require('./components/application/income/IncomeModal').default);
Vue.component('income-show', require('./components/application/income/IncomeShow').default);

Vue.component('index-correction', require('./components/application/correction/IndexCorrection').default);
Vue.component('correction-modal', require('./components/application/correction/CorrectionModal').default);
Vue.component('correction-payment-info', require('./components/application/correction/CorrectionInfo').default);

/**
 * RARC
 */
// Elaborar Proforma
Vue.component('elaborate-proforma-309-tabs', require('./components/elaborate-proforma/Tabs').default);
// Adjuntar Proforma
Vue.component('attach-proforma-309-table', require('./components/elaborate-proforma/attach-proforma/Index').default);

Vue.component('attach-proforma-213-table', require('./components/elaborate-proforma/attach-proforma/InmediatePaymentTable').default);

//Agrear detalle de tasas
Vue.component('proform-detail', require('./components/elaborate-proforma/attach-proforma/proform-detail/Index').default);
Vue.component('proform-detail-modal', require('./components/elaborate-proforma/attach-proforma/proform-detail/Modal').default);
// Vue.component('attach-proforma-309-modal', require('./components/elaborate-proforma/attach-proforma/Modal').default);
Vue.component('attach-proforma-309-modal', require('./components/elaborate-proforma/attach-proforma/Modal').default);
Vue.component('attached-proforma-files', require('./components/elaborate-proforma/attach-proforma/AttachedProformaFiles').default);
Vue.component('proform-observation-modal', require('./components/elaborate-proforma/attach-proforma/proform-detail/ObservationModal').default);
Vue.component('attach-proforma-replanning-modal', require('./components/elaborate-proforma/attach-proforma/ReplanningModal').default);

//card transaction
Vue.component('card-transaction-index', require('./components/card-transaction/Index').default);